module.exports = __webpack_public_path__ + "img/QRCodeForTaxInvoice.ed85eb00.png";